import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { useEffect, useState } from "react";
export var useContainerRef = function(ref) {
    var _useState = _sliced_to_array(useState(), 2), current = _useState[0], setCurrent = _useState[1];
    useEffect(function() {
        if (ref === null || ref === void 0 ? void 0 : ref.current) {
            setCurrent(ref.current);
        }
    }, [
        ref
    ]);
    return current;
};
